import { CounterJson } from '../empracoTypes';

export function ThousandSeparator (num: number) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

function StartCounting (counter: CounterJson, node: HTMLElement) {

  counter.started = true;

  // How long you want the animation to take in milliseconds
  const animationDuration = counter.time;

  // Calculate how long each "frame" should last if we want to update the animation 60 times per second
  const frameDuration = 1000 / 60;

  // Use that to calculate how many frames we need to complete the animation
  const totalFrames = Math.round(animationDuration / frameDuration);

  // An ease-out function that slows the count as it progresses
  const easeOutQuad = (time: number) => time * (2 - time);

  const animateCountUp = () => {
    let frame = 0;
    const countTo = counter.countTo;
    const interval = setInterval(() => {
      frame++;
      const progress = easeOutQuad(frame / totalFrames);
      if(counter.countFrom > counter.countTo) {
        const currentCount = Math.round((counter.countFrom - counter.countTo) * progress);
        let value: number = counter.countTo === 0 ? 1 : 0;
        if (counter.countFrom !== currentCount) {
          node.innerHTML = ThousandSeparator((counter.countFrom - currentCount) - value);
        }
      } else {
        const currentCount = Math.round((counter.countTo - counter.countFrom) * progress);
        let value: number = counter.countFrom === 0 ? 1 : 0;
        if (counter.countTo !== currentCount) {
          node.innerHTML = ThousandSeparator(counter.countFrom + currentCount + value);
        }
      }

      if (frame === totalFrames) {
        clearInterval(interval);
      }
    }, frameDuration);
  };

  animateCountUp();
}

export function Counter (counter: CounterJson) {
  const bodyHeight = document.body.getBoundingClientRect();
  const counterNode = document.getElementById(counter.id);

  if (!counterNode) {
    return;
  }

  const counterPos = counterNode.getBoundingClientRect();
  const offset = counterPos.top - bodyHeight.top;

  window.addEventListener('load', () => {
    if(!counter.started && counterPos.top >= 0 && window.scrollY + window.innerHeight >= offset) {
      StartCounting(counter, counterNode);
    }
  });

  // Initialize counter upon reached/scrolled to
  window.addEventListener('scroll', () => {
    if (!counter.started && window.scrollY + window.innerHeight >= offset) {
      StartCounting(counter, counterNode);
    }
  });
}